const BASE_URL = 'https://uat-api.getvisitapp.net/backend';
const BACKEND_TS_BASE_URL = 'https://uat-api.getvisitapp.net/backend-ts';
const PHARMACY_SERVICE_URL = 'https://uat-api.getvisitapp.net/pharmacy';
const NETWORK_SERVICE_URL = 'https://uat-network.getvisitapp.net';
const KEA_APP_URL = 'https://uat-kea.getvisitapp.net/vision';
const OPS_DASHBOARD_URL = 'https://uat-operations.getvisitapp.net/';
const MAORI_DASHBOARD_URL = 'https://uat-maori.getvisitapp.net/';
const CATALYST_DASHBOARD_URL = 'https://uat-catalyst.getvisitapp.net';
const DOCTOR_DASHBOARD_URL = 'https://uat-doctors.getvisitapp.net/home/';
const PAYMENT_SERVICE_URL = 'https://payments.getvisitapp.com';

const uat = {
  baseUrl: BASE_URL,
  backendTsBaseUrl: BACKEND_TS_BASE_URL,
  pharmacyService: PHARMACY_SERVICE_URL,
  networkService: NETWORK_SERVICE_URL,
  keaAppUrl: KEA_APP_URL,
  pubnub: {
    publishKey: 'pub-c-b8b14417-cff1-4e64-aa43-b41a777352cf',
    subscribeKey: 'sub-c-42db9ed2-315c-11e6-9327-02ee2ddab7fe',
  },
  googleAuthConfig: {
    clientId:
      '1063005261362-ahma70ju5no6aksoc95p9kivj7s3uopp.apps.googleusercontent.com',
    scopes: ['email', 'profile', 'openid'],
  },
  opsDashboardURL: OPS_DASHBOARD_URL,
  maoriDashboardURL: MAORI_DASHBOARD_URL,
  catalystDashboardURL: CATALYST_DASHBOARD_URL,
  doctorDashboardUrl: DOCTOR_DASHBOARD_URL,
  paymentServiceUrl: PAYMENT_SERVICE_URL,
  starHealthAccess: {
    allowedUserIds: [
      '397', '781', '29', '63', '62', '354', '1067', '1041', '81', '1111', '544', '263', '298',
      // Add your allowed userIds here
    ],
  },
  pacAccess: {
    allowedUserIds: [
      '3', '357', '665', '784', '1005',
      // Add your allowed userIds here
    ],
  },
};

export default uat;
